{
  "register-personal-data-page": {
    "buttons": {
      "next": "Next",
      "to-login": "To login"
    },
    "text": {
      "title": "Registration",
      "subtitle": "Register your new account",
      "have-account-question": "You have already account?",
      "personal-info": "Your personal info",
      "personal-info-hint": "Please enter your details below"
    }
  }
}
